import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "reactstrap";
import {
  getPlaceList,
  getCategories,
} from "../../redux/actions/indexActions";
import { AiOutlineEdit, AiOutlineDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Button } from "reactstrap";
import { MdAdd } from "react-icons/md";
import { Input } from "reactstrap";
import Pagination from "../../Components/Paginate";
import { CSVLink } from 'react-csv';
import { BiSolidFileExport } from 'react-icons/bi';
import { FaHeart, FaRegHeart } from 'react-icons/fa';


const Place = () => {
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth },
    indexReducer: {
      PlaceLists,
      placeCount,
      categoriesList
    },
    PermissionReducer: { allowedPermissions },
  } = useSelector((state) => state);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("");
  const [priority, setPriority] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [subSubCategory, setSubSubCategory] = useState("");
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [subSubCategoryList, setSubSubCategoryList] = useState([]);
  const [sort, setSort] = useState('desc');
  const [refresh, setRefresh] = useState(0);
  const [perPage, setPerPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [paginate, setPaginate] = useState(10);
  const [prevData, setPrevData] = useState({
    value: "",
    idx: "",
  });
  const indexOfLastItem = (page + 1) * paginate;
  const indexOfFirstItem = indexOfLastItem - paginate;
  useEffect(() => {
    dispatch(getPlaceList(auth?.token, paginate, page, search, sort, category, subCategory, subSubCategory, priority))
  }, [auth, paginate, page, search, sort, category, subCategory, subSubCategory, priority]);

  useEffect(() => {
    dispatch(getCategories(auth.token));
  }, [auth]);

  useEffect(() => {
    if (category) {

      axios(`/api/admin/v1/get-subcategory-by-category/${category}`)
        .then(({ data }) => {
          console.log(data, 'data loaded ');
          setSubCategoryList(data?.subCategoriesbyCategory);
        })
        .catch((err) => console.error(err));
    } else {
      setSubCategoryList([]);
    }
  }, [category]);

  useEffect(() => {
    if (subCategory) {
      axios(`/api/admin/v1/get-subsubcategory-by-subcategory/${subCategory}`)
        .then(({ data }) => {
          console.log(data, 'ldad');
          setSubSubCategoryList(data?.subSubCategoriesbySubCategory);
        })
        .catch((err) => console.error(err));
    } else {
      setSubSubCategoryList([]);
    }
  }, [subCategory]);

  const handleStatusChange = (value, idx) => {
    handleStatusSubmit(value, idx);
  }
  const handleStatusSubmit = (value, idx) => {
    setLoading(false);
    axios.post(`/api/admin/v1/priorty-status/status`,
      {
        value: value,
        id: idx,
      }, {
      headers: {
        Authorization: `Bearer ${auth.token}`,
      },
    }).then(() => {
        setPrevData({
          value: "",
          idx: "",
        });
        setRefresh(refresh => refresh + 1);
        toast.success("priorty updated successfully");
      })
      .catch((error) =>
        toast.error("Somthing Went Wrong")
      );
  };


  const csvHead = [['category', 'sub category', 'state', 'city', 'name', 'image', 'short description']]
  const csvData = PlaceLists.map((cv) => [
    cv?.category?.name,
    cv?.subCategory?.name_english,
    cv?.state?.state_name,
    cv?.city?.city_name,
    cv?.place_name,
    cv?.place_image,
    cv?.short_description,
  ])
  const exportData = csvHead.concat(csvData);


  const [selectedItems, setSelectedItems] = useState([]);

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedItems(PlaceLists.map((item) => item.id));
    } else {
      setSelectedItems([]);
    }
  };

  const handleSelectItem = (e, id) => {
    if (e.target.checked) {
      setSelectedItems([...selectedItems, id]);
    } else {
      setSelectedItems(selectedItems.filter((itemId) => itemId !== id));
    }
  };
  const isSelected = (id) => selectedItems.includes(id);
  console.log(selectedItems, 'isSelected')

  const handleDel = (id) => {
    // Check if place has gallery records
    axios.get(`/api/admin/v1/check-place-gallery/${id}`, {
      headers: { Authorization: `Bearer ${auth?.token}` }
    })
    .then((res) => {
      if (res.data.hasGallery) {
        toast.error("Cannot delete place with existing gallery records");
        return;
      }
      
      if (window.confirm("Are You Sure You Want To Delete This Place")) {
        axios
          .delete(`/api/admin/v1/place-delete/${id}`, {
            headers: {
              Authorization: `Bearer ${auth?.token}`,
            },
          })
          .then((res) => {
            toast.success(res.data.message);
            dispatch(getPlaceList(auth?.token, paginate, page, search, sort, category, subCategory, subSubCategory, priority));
          })
          .catch((err) => toast.error("Something Went Wrong"));
      }
    })
    .catch((err) => {
      // If API doesn't exist, show warning
      toast.warning("Cannot delete place with existing records");
    });
  };
  const handleDelALl = (selectedItems) => {
    if (window.confirm("Are You Sure You Want To Delete Selected Place")) {
      axios
        .post(`/api/admin/v1/multiple-place-delete`,
          { selectedItems }, {
          headers: {
            Authorization: `Bearer ${auth?.token}`,
          },
        })
        .then((res) => {
          toast.success(res.data.message);
          // dispatch(getPlaceList(auth?.token));
        })
        .catch((err) => toast.error("Somthing Went Wrong"));
    }
  };
  const [checkedItems, setCheckedItems] = useState({});
  useEffect(() => {
    if (PlaceLists && PlaceLists.length > 0) {
      const initialCheckedItems = PlaceLists.reduce((acc, item) => {
        acc[item.id] = item.booking_status === 1;
        return acc;
      }, {});
      setCheckedItems(initialCheckedItems);
    }
  }, [PlaceLists]);

  const handleCheckboxChange = async (id, checked) => {
    setCheckedItems((prev) => ({
      ...prev,
      [id]: checked,
    }));

    try {
      const response = await axios.put(
        '/api/admin/v1/update-book-status',
        {
          id,
          status: checked ? 1 : 0,
        },
        {
          headers: {
            Authorization: `Bearer ${auth?.token}`,
          },
        }
      );
      console.log('API response:', response.data);
    } catch (error) {
      console.error('Error updating book status:', error);
    }
  };
  const [lovedItems, setLovedItems] = useState({});
  useEffect(() => {
    if (PlaceLists && PlaceLists.length > 0) {
      const initialLovedItems = PlaceLists.reduce((acc, item) => {
        acc[item.id] = item.loved_place === 1;
        return acc;
      }, {});
      setLovedItems(initialLovedItems);
    }
  }, [PlaceLists]);

  const handleHeartClick = async (id) => {
    const newStatus = !lovedItems[id];
    setLovedItems((prev) => ({
      ...prev,
      [id]: newStatus,
    }));

    try {
      const response = await axios.put(
        '/api/admin/v1/update-loved-place',
        {
          id,
          status: newStatus ? 1 : 0,
        },
        {
          headers: {
            Authorization: `Bearer ${auth?.token}`,
          },
        }
      );
      console.log('API response:', response.data);
    } catch (error) {
      console.error('Error updating book status:', error);
    }
  };
  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <div className="mb-4 d-flex align-items-center justify-content-between" >
            <h5 className="mb-0 text-white fs-4">Place List</h5>
            {allowedPermissions?.some?.((item) => item?.permission?.moduleType === "PLACES" && item?.permission?.permission === "create") && (
              <Link to="/add-place">
                <Button className="bg-white text-black" size="sm">
                  <span className="me-2">
                    <MdAdd size={22} />
                  </span>
                  Add Place
                </Button>
              </Link>
            )}
          </div>
        </div>
      </div>
      <div className="bg-white px-3 py-4 rounded-2  my-4" style={{ boxShadow: "4px 4px 18px rgba(0,0,0,0.15)" }}>

        <div className="row">
          <div className="col-md-2 mb-2">
            <Input size={"sm"} value={search} placeholder='Search By Name' onChange={(({ target: { value } }) => setSearch(value))} />
          </div>
          <div className="col-md-2">
            <Input size={"sm"}
              type="select"
              name="category"
              value={category} onChange={(({ target }) => setCategory(target.value))}
            >
              <option value="">Select Category</option>
              {categoriesList?.map?.((item) => {
                return (
                  <option value={item.id} key={item.id}>
                    {item?.name}
                  </option>
                );
              })}
            </Input>
          </div>
          <div className="col-md-2">
            <Input size={"sm"}
              type="select"
              name="subCategory"
              value={subCategory} onChange={(({ target }) => setSubCategory(target.value))}
            >
              <option value="">Select Sub Category</option>
              {subCategoryList?.map?.((item) => {
                return (
                  <option value={item.id} key={item.id}>
                    {item?.name_english}
                  </option>
                );
              })}
            </Input>
          </div>
          <div className="col-md-3">
            <Input size={"sm"} type="select" name="subSubCategory" value={subSubCategory} onChange={(({ target }) => setSubSubCategory(target.value))}>
              <option value="">Select Sub Sub Category</option>
              {subSubCategoryList?.map?.((item) => {
                return (
                  <option value={item.id} key={item.id}>
                    {item?.name_english}
                  </option>
                );
              })}
            </Input>
          </div>
          <div className={`col-md-2 ${allowedPermissions?.some?.(
            (item) =>
              item?.permission?.moduleType === "PLACES" &&
              item?.permission?.permission === "export"
          ) ? "" : "offset-md-1"}`}>
            <Input type="select" size={"sm"} value={sort} onChange={(({ target }) => setSort(target.value))} >
              <option value="asc">Ascending</option>
              <option value="desc">Descending</option>
            </Input>
          </div>
          {allowedPermissions?.some?.((item) => item?.permission?.moduleType === "PLACES" &&
            item?.permission?.permission === "export") && (
              <div className="col-md-1 mb-2">
                <CSVLink
                  filename={
                    "place-lists.csv"
                  }
                  className="text-black ms-1"
                  title="Export To CSV"
                  data={exportData}
                >
                  <BiSolidFileExport size={25} />
                </CSVLink>
              </div>
            )}

          <div className="col-md-12">
            <button
              className="btn btn-secondary btn-sm mr-1"
              disabled={!selectedItems.length}
              // onClick={handleDel}
              onClick={() => handleDelALl(selectedItems)}
            >
              <i className="fa fa-trash pr-1" />{" "}
              Delete
            </button>
            <Table hover responsive>
              <thead>
                <tr>
                  <th>
                    <Input type="checkbox" onChange={handleSelectAll} checked={selectedItems.length === PlaceLists.length} />
                  </th>
                  <th>SL. No.</th>
                  <th>Category</th>
                  <th>Sub Category</th>
                  <th>Sub Sub Category</th>
                  <th>State</th>
                  <th>City</th>
                  <th>Book</th>
                  <th>Wishlist</th>
                  <th>Name</th>
                  <th>Image</th>
                  <th>Place Details</th>
                  {allowedPermissions?.some?.(
                    (item) =>
                      item?.permission?.moduleType === "PLACES" &&
                      (item?.permission?.permission === "edit" ||
                        item?.permission?.permission === "delete")
                  ) && (
                      <th>Action</th>
                    )}
                </tr>
              </thead>
              <tbody>
                {PlaceLists.length === 0 ? (
                  <tr>
                    <td colSpan="12">No data found</td>
                  </tr>
                ) : (<>
                  {PlaceLists?.map?.((item, index) => {
                    return (
                      <tr key={item.id}>

                        <td> <Input
                          type="checkbox"
                          checked={isSelected(item.id)}
                          onChange={(e) => handleSelectItem(e, item.id)}
                        /></td>
                        <td scope="row">{index + 1 + page * paginate}</td>
                        <td> {item?.place_category_ids.map(item => item?.category?.name).join(',')} </td>
                        <td>{item?.place_sub_category_ids.map(item => item?.sub_category?.name_english).join(',')}</td>
                        <td>{item?.place_sub_sub_category_ids.map(item => item?.sub_sub_category?.name_english).join(',')}</td>
                        <td>{item?.state?.state_name}</td>
                        <td>{item?.city?.city_name}</td>
                        <td>
                          <input type="checkbox" checked={checkedItems[item.id] || false}
                            onChange={(e) => handleCheckboxChange(item.id, e.target.checked)} />
                        </td>
                        <td>
                          {lovedItems[item.id] ? (
                            <FaHeart color="red" style={{ marginLeft: '5px' }}
                              onClick={(e) => handleHeartClick(item.id, e.target.checked)} />
                          ) : (
                            <FaRegHeart color="gray" style={{ marginLeft: '5px' }}
                              onClick={(e) => handleHeartClick(item.id, e.target.checked)} />
                          )}
                        </td>
                        <td>{item?.place_name}</td>
                        <td>
                          <img src={process.env.REACT_APP_IMAGE_URL + `/${item?.place_image}`} height={45} width={45} />
                        </td>
                        <td>
                          <Link to={`/add-place-details/${item?.id}`}>
                            <MdAdd size={22} />
                          </Link>
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            {allowedPermissions?.some?.(
                              (item) =>
                                item?.permission?.moduleType ===
                                "PLACES" &&
                                item?.permission?.permission === "edit"
                            ) && (
                                <Link to={`/edit-place/${item?.id}`}>
                                  <AiOutlineEdit
                                    size={22}
                                    className="text-warning me-3"
                                  />
                                </Link>
                              )}
                            {allowedPermissions?.some?.(
                              (item) =>
                                item?.permission?.moduleType ===
                                "PLACES" &&
                                item?.permission?.permission === "delete"
                            ) && (
                                <AiOutlineDelete
                                  size={22}
                                  className="text-danger"
                                  onClick={() => handleDel(item.id)}
                                />
                              )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}</>
                )}
              </tbody>
            </Table>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-md-6 d-flex">
            <div className="col-md-2">
              <Input
                type="select"
                id="paginate"
                onChange={e =>
                  setPaginate(
                    e.target.value
                  )
                }
                value={paginate}
                className="paging custom-select custom-select-page m-0"
              >
                <option value="10">
                  10
                </option>
                <option value="20">
                  20
                </option>
                <option value="50">
                  50
                </option>
                <option value="100">
                  100
                </option>
                <option value="200">
                  200
                </option>
                <option value="500">
                  500
                </option>
              </Input>
            </div>
            <div className='col-md-10 text-black d-flex align-items-center ps-3'>
              {placeCount > 0 ? (
                <>
                  Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, placeCount)} of {placeCount} entries
                </>
              ) : (
                <>
                  Showing 0 to 0 of 0 entries
                </>
              )}
            </div>
          </div>
          <div className='col-md-6'>
            <div className='d-flex justify-content-end'>
              <Pagination
                pageCount={(placeCount) / paginate}
                onChange={(e) => setPage(e.selected)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Place;
